import { format } from "date-fns";
import { useEffect } from "react";
import { Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import TextArea from "../../../../ui/molecules/textArea";
import { activityOptions, resultOptions, valutatoreOptions } from "../../../../utils";
import { GetByIdPersonalManagement } from "../../slice";
import { EvaluationCreation, EvaluationValidation, resetEvaluationCreationRequest, resetEvaluationCreationStatus, resetEvaluationError, resetEvaluationValidationStatus, setEvaluationActivityId, setEvaluationDate, setEvaluatorId, setNote, setResult } from "../slice";

interface Props {
    close: () => void;
}

export function ValutazioniPopupAdd(props: Props) {
    const evaluationState = useAppSelector(state => state.PMEvaluations);
    const PMState = useAppSelector(state => state.personalManagement);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (evaluationState.evaluationValidationStatus === 'successfully') {
            dispatch(resetEvaluationValidationStatus());
            dispatch(resetEvaluationError());
            dispatch(EvaluationCreation(evaluationState.evaluationCreationRequest));
        }
    }, [evaluationState.evaluationValidationStatus]);

    useEffect(() => {
        if (evaluationState.evaluationCreationStatus === 'successfully') {
            dispatch(resetEvaluationCreationStatus());
            dispatch(resetEvaluationCreationRequest());
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!));
            props.close();
        }
    }, [evaluationState.evaluationCreationStatus]);

    return (
        <Fragment>
            <div className="p-6 bg-white flex flex-col gap-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <Calendar
                        label="Data valutazione"
                        selected={evaluationState.evaluationCreationRequest.evaluationDate}
                        onChange={(date) => {
                            dispatch(setEvaluationDate(format(new Date(date), 'yyyy-MM-dd')));
                        }}
                    />
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Attività da valutare"
                        placeholder="Attività da valutare"
                        options={activityOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null;
                            dispatch(setEvaluationActivityId(newValue));
                        }}
                        value={evaluationState.evaluationCreationRequest.evaluationActivityId}
                        error={evaluationState.evaluationError.evaluationActivityId}
                        errorLabel="Attività mancante"
                        noOptionsMessage={""}
                    />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Valutatore"
                        placeholder="Valutatore"
                        options={valutatoreOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null;
                            dispatch(setEvaluatorId(newValue));
                        }}
                        value={evaluationState.evaluationCreationRequest.evaluatorId}
                        error={evaluationState.evaluationError.evaluatorId}
                        errorLabel="Valutatore mancante"
                        noOptionsMessage={""}
                    />
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Esito"
                        placeholder="Esito"
                        options={resultOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null;
                            dispatch(setResult(newValue));
                        }}
                        value={evaluationState.evaluationCreationRequest.result}
                        error={evaluationState.evaluationError.result}
                        errorLabel="Esito mancante"
                        noOptionsMessage={""}
                    />
                </div>

                <div className="grid grid-cols-1 gap-4">
                    <TextArea
                        label="Note sulla valutazione"
                        onChangeText={(text) => dispatch(setNote(text))}
                    />
                </div>

                <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        variant="outline"
                        iconPosition="off"
                        label="Annulla"
                        color="gray"
                        onClick={() => {
                            dispatch(resetEvaluationError());
                            dispatch(resetEvaluationCreationRequest());
                            props.close();
                        }}
                    />
                    <ButtonComponent
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Aggiungi"
                        color="orange"
                        onClick={() => {
                            dispatch(EvaluationValidation(evaluationState.evaluationCreationRequest));
                        }}
                    />
                </div>
            </div>
        </Fragment>
    );
}